import { MaintenanceForwardingEstablishmentChoiceEntryAuctionEntryData } from "@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/establishmentChoiceEntries/auctionEntry/auctionEntry.type";

interface AuctionEntryStatusProps {
  status: MaintenanceForwardingEstablishmentChoiceEntryAuctionEntryData['status'] | undefined;
}

const AuctionEntryStatus = ({
  status
}: AuctionEntryStatusProps) => {
  if (status === 'pending') {
    return (
      <p className="text-warning text-xs">
        Aguardando início
      </p>
    );
  }

  if (status === 'in_progress') {
    return (
      <p className="text-warning text-xs">
        Em andamento
      </p>
    );
  }

  if (status === 'completed') {
    return (
      <p className="text-success text-xs">
        Finalizado
      </p>
    );
  }

  if (status === 'canceled') {
    return (
      <p className="text-danger-soft text-xs">
        Cancelado
      </p>
    );
  }

  return null;
}

export default AuctionEntryStatus;
